import { Box, Button, Popover, PopoverProps, styled } from '@mui/material'
import { JSXElementConstructor, MouseEvent, ReactNode, useState } from 'react'

const StyledButton = styled(Button)`
  background-color: #0b0b0c;
  color: white;
  padding: 8px;
  border-radius: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 160px;
  text-transform: none;
  font-weight: 300;

  :disabled {
    background-color: #535556;
    color: #a0a0a0;

    .MuiTypography-root {
      color: #a0a0a0;
    }
  }
`

const StyledPopover = styled(Popover)`
  ${props => {
    return `z-index: ${props.theme.zIndex.modal + 1}`
  }};
`

/**
 * Custom dropdown component use Popover from MUI
 */
const CustomDropdown = ({
  className,
  children,
  renderDropdownContent,
  disabled,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'left'
  },
  PopoverComponent = StyledPopover
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const isOpen = Boolean(anchorEl)

  return (
    <>
      <StyledButton
        disabled={disabled}
        className={className}
        onClick={handleClick}
      >
        {children}
        <Box>{isOpen ? '▲' : '▼'}</Box>
      </StyledButton>
      <PopoverComponent
        open={isOpen}
        anchorEl={anchorEl}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
      >
        {renderDropdownContent({ closeDropdown: handleClose })}
      </PopoverComponent>
    </>
  )
}

type Props = {
  className?: string
  disabled?: boolean
  children: ReactNode
  renderDropdownContent: ({
    closeDropdown
  }: {
    closeDropdown: () => void
  }) => ReactNode
  PopoverComponent?: JSXElementConstructor<PopoverProps>
  anchorOrigin?: PopoverProps['anchorOrigin']
  transformOrigin?: PopoverProps['transformOrigin']
}

export { StyledPopover as CustomDropdownPopover }

export default CustomDropdown
